module.exports = __webpack_public_path__ + "static/mirrors-a35eb2a913193e9cdadf89551787e001.png";